import type { TFunction } from "react-i18next";
import type { StatusColor } from "../../../components/Status/Status";
import type {
  DeprecatedLeadStatus,
  Lead,
  LeadStatus,
  SampleRequestStatusUnion,
} from "../../../types/types";
import type { FiltersDropDownItem } from "../../../components/FiltersDropDown/FiltersDropDown";

type StatusDetails = {
  text: string;
  color: StatusColor;
};

/**
 * Returns UI details for a given lead status, for seller admins.
 */
export const getLeadStatusDetails = (
  status: LeadStatus,
  t: TFunction
): StatusDetails => {
  switch (status) {
    case "New":
      return { text: t("New"), color: "blue" };
    case "Forwarded":
      return { text: t("Forwarded"), color: "fullBlue" };
    case "Added as User":
      return { text: t("Added as User"), color: "fullBlue" };
    case "Added as Address":
      return { text: t("Added as Address"), color: "fullBlue" };
    case "Converted":
      return { text: t("Converted"), color: "green" };
    case "Accepted":
      return { text: t("Accepted"), color: "green" };
    case "Rejected":
      return { text: t("Rejected"), color: "red" };
    case "Lead Declined":
      return { text: t("Declined"), color: "red" };
    case "blocked":
      return { text: t("Blocked"), color: "red" };
    case "Sent to Distributor":
      return { text: t("Sent to Distributor"), color: "blue" };
    case "Rejected by Distributor":
      return { text: t("Rejected by Distributor"), color: "red" };
    case "Accepted by Distributor":
      return { text: t("Accepted by Distributor"), color: "green" };
    case "followed_externally":
      return { text: t("Followed Externally"), color: "blue" };
    default:
      return { text: status, color: "gray" };
  }
};

export type StatusCellProps = {
  color: StatusColor;
  lead: Lead;
  text: string;
};

export const LeadStatusFilters = (
  t: (s: string) => string
): FiltersDropDownItem<Exclude<LeadStatus, DeprecatedLeadStatus>>[] => [
  { color: "blue", text: t("New"), value: "New" },
  { color: "fullBlue", text: t("Added as User"), value: "Added as User" },
  { color: "fullBlue", text: t("Added as Address"), value: "Added as Address" },
  { color: "green", text: t("Accepted"), value: "Accepted" },
  { color: "red", text: t("Rejected"), value: "Rejected" },
  { color: "red", text: t("Blocked"), value: "blocked" },
  {
    color: "blue",
    text: t("Sent to Distributor"),
    value: "Sent to Distributor",
  },
  {
    color: "red",
    text: t("Rejected by Distributor"),
    value: "Rejected by Distributor",
  },
  {
    color: "green",
    text: t("Accepted by Distributor"),
    value: "Accepted by Distributor",
  },
  {
    color: "blue",
    text: t("Followed Externally"),
    value: "followed_externally",
  },
];

export const SampleRequestStatusFilters = (
  t: (s: string) => string
): FiltersDropDownItem<SampleRequestStatusUnion>[] => [
  { color: "blue", text: t("New"), value: "requested" },
  { color: "fullBlue", text: t("Added as User"), value: "Added as User" },
  { color: "fullBlue", text: t("Added as Address"), value: "Added as Address" },
  { color: "green", text: t("Accepted"), value: "accepted" },
  { color: "red", text: t("Rejected"), value: "rejected" },
  { color: "red", text: t("Blocked"), value: "blocked" },
  {
    color: "blue",
    text: t("Sent to Distributor"),
    value: "sent_to_distributor",
  },
  {
    color: "red",
    text: t("Rejected by Distributor"),
    value: "rejected by distributor",
  },
  {
    color: "green",
    text: t("Accepted by Distributor"),
    value: "accepted by distributor",
  },
  {
    color: "blue",
    text: t("Followed Externally"),
    value: "followed_externally",
  },
];

export const DistributorLeadStatusFilters = (
  t: (s: string) => string
): FiltersDropDownItem<Exclude<LeadStatus, DeprecatedLeadStatus>>[] => [
  { color: "blue", text: t("New"), value: "New" },
  { color: "green", text: t("Accepted"), value: "Accepted" },
  { color: "red", text: t("Rejected"), value: "Rejected" },
];

export const DistributorSampleLeadStatusFilters = (
  t: (s: string) => string
): FiltersDropDownItem<SampleRequestStatusUnion>[] => [
  { color: "blue", text: t("New"), value: "requested" },
  { color: "green", text: t("Accepted"), value: "accepted" },
  { color: "red", text: t("Rejected"), value: "rejected" },
];
